<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ 'GK.MAP.EXTERNAL_MODAL_WMS.TITLE' | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-describedby="modal-title"
    (click)="closeModal()"
  >
    <span class="sr-only">{{ 'GK.MAP.EXTERNAL_MODAL_WMS.CLOSE_WINDOW' | translate }}</span>
  </button>
</div>
<div class="modal-body">
  <div class="mt-3">
    <label
      class="form-check-label control-required-label"
      for="wms-url"
    >
      {{ 'GK.MAP.EXTERNAL_MODAL_WMS.URL' | translate }}
    </label>
    <div class="d-flex gap-2">
      <input
        class="form-control"
        type="text"
        id="wms-url"
        [(ngModel)]="wmsUrl"
        (ngModelChange)="handleUrlChanged()"
        aria-required="true"
      />
      <button
        type="button"
        class="btn btn-outline-color-from-db d-flex align-items-center justify-content-center text-center px-4"
        (click)="handleClickConnect()"
        [disabled]="!wmsUrl"
      >
      <span [style.visibility]="pendingRequest ? 'hidden' : 'visible'">
      {{ 'GK.MAP.EXTERNAL_MODAL_WMS.CONNECT' | translate }}
    </span>
      <i
        *ngIf="pendingRequest"
        class="fa fa-spinner fa-spin fa-sm position-absolute"
      ></i>
      </button>
    </div>

  </div>
  <div class="mt-3">
    <label
      class="form-check-label control-required-label"
      for="wms-name"
    >
      {{ 'GK.MAP.EXTERNAL_MODAL_WMS.NAME' | translate }}
    </label>
    <input
      class="form-control"
      type="text"
      id="wms-name"
      [(ngModel)]="optionalName"
      aria-required="true"
    />
  </div>
  @if (layers.length) {
    <div class="mt-4" style="max-height: 200px; overflow-y: auto;">
      <div class="form-check gap-2 d-flex">
        <h5>{{ 'GK.MAP.EXTERNAL_MODAL_WMS.LAYERS' | translate }}</h5>
        <button
          type="button"
          class="btn btn-sm btn-light d-flex align-items-center"
          (click)="toggleAllLayersWithIcon()"
          [attr.aria-label]="allSelected ? ('GK.MAP.EXTERNAL_MODAL_WMS.UNSELECT_ALL' | translate) : ('GK.MAP.EXTERNAL_MODAL_WMS.SELECT_ALL' | translate)"
          [title]="allSelected ? ('GK.MAP.EXTERNAL_MODAL_WMS.UNSELECT_ALL' | translate) : ('GK.MAP.EXTERNAL_MODAL_WMS.SELECT_ALL' | translate)"
          [innerHTML]="currentIconHtml">
        </button>
      </div>
      <div class="ps-2">
        <div *ngFor="let layer of layers" class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            [id]="'layer-' + layer.name"
            [(ngModel)]="layer.selected"
          />
          <label class="form-check-label" [for]="'layer-' + layer.name">
            {{ layer.title }}
          </label>
        </div>
      </div>
    </div>
  }

</div>
@if (layers.length) {
  <div class="modal-footer flex-column flex-nowrap">
    <div class="d-flex align-items-center justify-content-end flex-wrap flex-sm-nowrap w-100 gap-2">
      <button
        type="button"
        class="btn btn-color-from-db"
        (click)="addWmsToLayerTree()"
      >
        {{ 'GK.MAP.EXTERNAL_MODAL_WMS.ADD_TO_MAP' | translate }}
      </button>
    </div>
  </div>
}
